import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchResultsInfinite } from '@uncinc/react-searchkit';

import { SearchAllContentHit } from '../types';
import Hit from './Hit';

export interface SearchAllContentResultsProps {
  className?: string;
}

const SearchAllContentResults: React.FC<SearchAllContentResultsProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Results', className);

  return (
    <SearchResultsInfinite
      className={classNames}
      showMoreButtonText={t('searchkit.buttons.show_more')}
      renderItem={(hit: SearchAllContentHit) => <Hit hit={hit} />}
    />
  );
};

export default SearchAllContentResults;
